import React from 'react';

// INTERFACES
import { ISkeleton } from '../../interfaces/Skeleton.interface';

// STYLES
import { Container } from './styles';

const Skeleton: React.FC<ISkeleton> = ({ type, ...rest }: ISkeleton) => {
  return <Container type={type} {...rest} />;
};

export default Skeleton;
